import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments';
import { HandleError } from '../http-error-handler.service';
import { AjusteManualAeroespecialidad } from '@shared/models/stock/AjusteManualAeroespecialidad';
import { AjusteManualCombustible } from '@shared/models/stock/AjusteManualCombustible';
import { ComprobanteSalida } from '@shared/models/stock/ComprobanteSalida';
import { Motivo } from '@shared/models/stock/Motivo';
import { StockAeroespecialidad } from '@shared/models/stock/StockAeroespecialidad';
import { Transaccion } from '@shared/models/stock/Transaccion';
import { Trasvase } from '@shared/models/stock/Trasvase';
import { AnulacionDTO } from '@shared/models/stock/AnulacionDTO';
import {filtrosReporteMovimientosDTO} from "@shared/models/stock/FiltrosReporteMovimientosDTO";
import { Recepcion } from '@shared/models/stock/Recepcion';

@Injectable({
  providedIn: 'root'
})
export class TransaccionesService {

  stockbaseUrl = environment.apiServer.stockBaseUrl;
  private movimientosURL = this.stockbaseUrl + '/TransaccionesV1';
  private aeroplantasURL = this.stockbaseUrl + '/AeroplantasV1';

  private handleError: HandleError;

  constructor(private httpClient: HttpClient) { }

  getTransacciones(codigo: string, fechaInicio: string, fechaFin: string): Observable<Transaccion[]> {
    return this.httpClient.get<Transaccion[]>(this.movimientosURL + '?codigoAeroplanta=' + codigo + '&fechaDesde=' + fechaInicio + '&fechaHasta=' + fechaFin);
  }

  getTransaccionPorId(id: string): Observable<Transaccion> {
    return this.httpClient.get<Transaccion>(this.movimientosURL + '/' + id)
  }

  getTransaccionPorIdConComprobante(id: string): Observable<ComprobanteSalida> {
    return this.httpClient.get<ComprobanteSalida>(this.movimientosURL + '/' + id + '/Comprobantes')
  }

  getRemitoCargamentoPorId(remitoId: string): Observable<Recepcion> {
    return this.httpClient.get<Recepcion>(this.stockbaseUrl + '/TransaccionesV2/remitoCargamento/' + remitoId)
  }

  postTrasvase(trasvase: Trasvase): Observable<Trasvase> {
    return this.httpClient.post<Trasvase>(this.movimientosURL + '/Trasvasar', trasvase);
  }

  anularMovimiento(id: string){
    return this.httpClient.put(this.movimientosURL + '/' + id + '/Anulacion', '');
  }

  anularMovimientoRecepcion(anulacionDto: AnulacionDTO): Observable<string> {
    return this.httpClient.put(this.stockbaseUrl + '/TransaccionesV2/AnularRemitoCargamento', anulacionDto, {responseType: 'text'})
  }

  getMotivos(): Observable<Motivo[]> {
    return this.httpClient.get<Motivo[]>(this.movimientosURL + '/Motivos')
  }

  realizarAjusteManualCombustible(ajuste: AjusteManualCombustible): Observable<AjusteManualCombustible> {
    return this.httpClient.post<AjusteManualCombustible>(this.movimientosURL + '/AjusteManual', ajuste);
  }

  getAeroespecialidades(codigoAeroplanta): Observable<StockAeroespecialidad[]> {
    return this.httpClient.get<StockAeroespecialidad[]>(this.aeroplantasURL + '/'+ codigoAeroplanta + '/StockAeroespecialidades')
  }

  realizarAjusteManualAeroespecialidad(codigoAeroplanta, ajuste: AjusteManualAeroespecialidad): Observable<AjusteManualAeroespecialidad> {
    return this.httpClient.put<AjusteManualAeroespecialidad>(this.movimientosURL + '/AjusteManualAeroespecialidad?codigoAeroplanta=' + codigoAeroplanta, ajuste);
  }

  putMovimientosRecargas(movimientos: filtrosReporteMovimientosDTO): Observable<any[]>{
    return this.httpClient.put<any[]>(this.movimientosURL + '/TransaccionesRecargasPorFecha', movimientos);
  }

  putMovimientosRecepciones(movimientos: filtrosReporteMovimientosDTO): Observable<any[]>{
    return this.httpClient.put<any[]>(this.movimientosURL + '/TransaccionesRecepcionesPorFecha', movimientos);
  }
}
